<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="menu_id" class="block text-sm font-medium text-gray-700">Menú</label>
      <select id="menu_id" :value="loadData.menu_id"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              @change="(rolIdNew)=>$emit('updateValues', {'menu_id': rolIdNew.target.value, 'status' : true})">
        <option value="" selected>Seleccione un menú...</option>
        <option v-for="(menu, index) of collectionMenus" :key="'B'+index"
                :value="menu.id">{{ menu.alias }} - {{ menu.name }}
        </option>
      </select>
    </div>
    <div v-if="parentView === 'crear'" class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="permisos" class="block text-sm font-medium text-gray-700">Permisos Recursivos</label>
      <input
          ref="theCheckbox"
          @change="(recursivo)=>$emit('updateValues', {'status' : true})"
          id="recursivo"
          type="checkbox"
          class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
      />
      <b class="py-4 ml-2 break-all text-sm font-medium text-gray-900 dark:text-gray-300">
           (View, Add, Edit, Delete)
      </b>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="nombre" class="block text-sm font-medium text-gray-700">Nombre</label>
      <input type="text" id="nombre" :value="loadData.nombre"
             :style="styleName"
             @change="(nombreNew)=>$emit('updateValues', {'nombre': nombreNew.target.value})"
             :disabled="disabledName"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="descripcion" class="block text-sm font-medium text-gray-700">Descripción</label>
      <input type="text" id="descripcion" :value="loadData.descripcion"
             @change="(descripcionNew)=>$emit('updateValues', {'descripcion': descripcionNew.target.value})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
  </div>
</template>

<script>
import {ref} from "vue";
import {useAPIRest,  swal} from "@/common/constants";

/**
 * Un componente con el formulario para crear o actualizar un permiso.
 * @vue-prop {Object} loadData - Los datos presentes en el formulario.
 * @vue-prop {String} parentView - La vista del componente padre.
 * @vue-event {Object} updateValues - Emite un objeto para actualizar una propiedad del componente padre.
 */
export default {
  name: 'PermisosCrearActualizarComponent',
  props: {
    loadData: Object,
    parentView: String
  },
  emits: ["updateValues"],
  async setup(props,{emit}) {
  // async setup(props) {

    const collectionMenus = ref([]);
    collectionMenus.value = await useAPIRest(process.env.VUE_APP_NEST_MENU_FINDALL, 'GET', props.authToken, undefined, {
      page: 1,
      orderBy: 'created_at',
      order: 'ASC',
      criterion: '',
      search: '',
      where: '',
      isPaginate: false
    });

    if(props.parentView == 'crear'){
      emit('updateValues', {
        'status' : false,
        'id' : 1
      })
    }

    return {
      collectionMenus,
      disabledName : false,
      styleName : '',
    }
  },
  watch: {
    'loadData': {
      handler: function (val) {
        let {status,menu_id } = val;

        if(status){
          if(this.$refs.theCheckbox.checked){
            if(menu_id == ''){
              swal.fire({
                title: 'Selecciona un menú.',
                icon: 'info'
              })

              this.$emit('updateValues', {
                      'status' : false,
                      'nombre' :''
              });

              this.$refs.theCheckbox.checked = false
              this.disabledName = false
              this.styleName    = ""

            }else{
              let nameMenu = ''
              for(let menu in this.collectionMenus){
                if(this.collectionMenus[menu].id == menu_id){
                  nameMenu = this.collectionMenus[menu].name
                }
              }
              if(nameMenu != 'SinComponente'){
                this.$emit('updateValues', {
                        'status' : false,
                        'nombre' : [
                          'view_'  +nameMenu,
                          'add_'   +nameMenu,
                          'edit_'  +nameMenu,
                          'delete_'+nameMenu,
                        ]
                });
                this.disabledName = true
                this.styleName    = "background-color: #f3f3f3"
              }else{
                this.$emit('updateValues', {
                      'status' : false,
                      'nombre' :''
                });
                this.$refs.theCheckbox.checked = false
                this.disabledName = false
                this.styleName    = ""
              }

            }
          }else{
            this.$emit('updateValues', {
                    'status' : false,
                    'nombre' : ''
            });
              
            this.disabledName = false
            this.styleName    = ""
          }
        }
      },
      deep: true
    }
  }
}
</script>